{
  "schema": "holzcom.viewer.module_library.v1",
  "topLevelKeys": [
    "schema",
    "generatedAt",
    "previewMode",
    "count",
    "offset",
    "limit",
    "hasMore",
    "categories",
    "items",
    "errors",
    "statusCounts"
  ],
  "errorKeys": ["id", "detail"],
  "statusCountKeys": ["READY", "BUILDABLE", "BLOCKED"]
}
